import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';
import AppMainContent from '@/components/AppMainContent.vue';
import AppMainContentLayout from '@/components/AppMainContentLayout.vue';
import AppFocusLock from '@/components/AppFocusLock.vue';

import App from './App.vue';
import router from './router';
import store from './store';
import { components as elementUiComponents, plugins } from './plugins/element-ui/index';
import FontAwesomeIcon from './plugins/font-awesome/index';
import SmartlookPlugin from './plugins/smartlook/index';

const app = createApp(App);
app.use(store);
app.use(router);
app.component('fai', FontAwesomeIcon);
app.component('app-main-content', AppMainContent);
app.component('app-main-content-layout', AppMainContentLayout);
app.component('app-focus-lock', AppFocusLock);

elementUiComponents.forEach((component) => {
  if (component.name) {
    app.component(component.name, component);
  }
});

plugins.forEach((plugin) => {
  app.use(plugin);
});

// Initialize Smartlook
const smartlookKey = import.meta.env.VITE_SMARTLOOK_KEY;
const smartlookRegion = import.meta.env.VITE_SMARTLOOK_REGION || 'eu';

if (smartlookKey) {
  app.use(SmartlookPlugin, {
    key: smartlookKey,
    region: smartlookRegion as 'eu' | 'us',
  });
}

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
});

app.mount('#app');
